	export enum SalesOrderExchangeTypeEnum {
		Empty = 1,
		ProductsOnly = 2,
		AllItems = 3
	}
